export default {
    name: "Shipping Bill Mapper",
    path: "/shipping-bill-mapper",
    meta: {
        icon: "speaker_notes",
        auth: true
    },
    departmentName: "Shipping Bill Mapper",
    finalPagePermision: "Shipping Bill Mapper",

    component: require("../component/shipping_bill_mapper/Tab.vue")
};


// WEBPACK FOOTER //
// ./src/sidebar/shippingBill.js